import {
  DiscoveryApi,
  discoveryApiRef,
  IdentityApi,
  identityApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { useCallback } from 'react';
import { Entity } from '@backstage/catalog-model';

export interface StructureModelInterface {
  id: string;
  name: string;
  category?: string;
  type?: string;
  parent?: StructureModelInterface;
  children?: StructureModelInterface[];
}

export interface Structure {
  businesscapability?: StructureModelInterface;
  organizationstructure?: StructureModelInterface;
  techcategory?: StructureModelInterface;
  application?: StructureModelInterface;
}

const fetchData = async <T>({
  baseUrl,
  token,
  pathname,
}: {
  baseUrl: string;
  token?: string;
  pathname: string;
}): Promise<T> => {
  const response = await fetch(`${baseUrl}/${pathname}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.json();
};

async function fetchDataFromApi(
  discoveryApi: DiscoveryApi,
  identityApi: IdentityApi,
  annotation: string,
): Promise<StructureModelInterface> {
  const baseUrl = await discoveryApi.getBaseUrl('leanix');
  const path = `inventory/${annotation}`;
  const { token } = await identityApi.getCredentials();

  return fetchData<StructureModelInterface>({
    baseUrl,
    token,
    pathname: path,
  });
}

export function useInventory(): (entity: Entity) => Promise<Structure> {
  const discoveryApi = useApi(discoveryApiRef);
  const identityApi = useApi(identityApiRef);

  const fetchResponse = useCallback(
    async (entity: Entity) => {
      const response: Structure = {};

      if (entity.metadata.annotations!['leanix/application-id']) {
        response.application = await fetchDataFromApi(
          discoveryApi,
          identityApi,
          entity.metadata.annotations!['leanix/application-id'],
        );
      }
      return response;
    },
    [discoveryApi, identityApi],
  );

  return fetchResponse;
}
